import React, { useEffect, useState } from 'react'
import "./DesignContentEdit.scss";
import { CloudUpload } from '@livingdesign/icons';
import EditFormActionsFooter from './EditFormActionsFooter';
import { useMessageDetailsForm } from '../../../../../contexts/MessageDetailsForm';
import TemplateOverlay from './TemplateSection/TemplateOverlay';
import { useCampaignContext } from '../../../../../contexts/Campaign';
import TemplateThumbnail from '../../../../template/TemplateThumbnail';
import DOMPurify from "dompurify";
import { Button, Divider } from '@livingdesign/react';
import TemplateGalleryPreview from '../../../../template/TemplateGalleryPreview';
import { GALLERY_SCHEMA } from '../../../../../consts/Template';
import InputErrorText from '../../../common/Error/InputErrorText';
import { TEMPLATE, CONFIGURATIONS, NOTIFICATION } from '../../../../../consts/DBFields';
import { CAMPAIGN_FIELDS_V2 } from '../../../../../consts/Campaign';
import AttachmentUploadContainer from './FormComponents/AttachmentUploadContainer';

const QA_ID_PREFIX = "DesignContentEdit";

function DesignContentEdit({
  stepIndex,
}) {

  const {
    templatePreview,
    selectedTemplate,
  } = useCampaignContext();

  const {
    continueButtonLoading,
    handleContinue,
    handlePrevious,
    saveCampaign,
    selectedCampaign,
    showTemplateOverlay,
    setShowTemplateOverlay,
    isOverlayOn,
    channel,
    templatePreviewDetails,
    setTemplatePreviewDetails,
    errors,
    saveDraft,
    control,
    Controller
  } = useMessageDetailsForm();
  // console.log({errors});
  
  const [editSelectedTemplate, setEditSelectedTemplate] = useState(false);

  useEffect(() => {
    if(!isOverlayOn(!showTemplateOverlay)) {
      setEditSelectedTemplate(false);
    }
  }, []);
  
  return (
    <>
      <div style={{display: (isOverlayOn() ? "none" : "block")}} data-testid={`${QA_ID_PREFIX}-MainContainer`}>
        <div className='design-content-edit-title' data-testid={`${QA_ID_PREFIX}-Title`}>
          <h2 data-testid={`${QA_ID_PREFIX}-Heading`}>Design your message content</h2>
          <p data-testid={`${QA_ID_PREFIX}-Description`}>The supporting body text should be clear, meaningful, and helpful, guiding users to understand what actions they can take.</p>
        </div>
        {selectedTemplate?.[TEMPLATE.ID]
          ?
          <div
            className="design-content-template-preview"
            id={`${QA_ID_PREFIX}-TemplateThumbnail`}
            data-testid={`${QA_ID_PREFIX}-SelectedTemplatePreview`}
          >
            <h3 data-testid={`${QA_ID_PREFIX}-SelectedTemplateHeading`}>Your selected template</h3>
            <div className='design-content-template-preview-container' data-testid={`${QA_ID_PREFIX}-TemplatePreviewContainer`}>
              <div data-testid={`${QA_ID_PREFIX}-TemplatePreviewWrapper`}>
                <div
                  className='html-template-preview-overlay'
                  onClick={() => {
                    if(!templatePreview) return;
                    setTemplatePreviewDetails({
                      showPreview: true,
                      template: {[GALLERY_SCHEMA.PREVIEW]: templatePreview},
                      title: selectedTemplate?.name,
                    });
                  }}
                  data-testid={`${QA_ID_PREFIX}-TemplatePreviewOverlay`}
                />
                <div
                  className='html-template-preview'
                  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(templatePreview) }}
                  data-testid={`${QA_ID_PREFIX}-TemplatePreviewHtml`}
                />
              </div>
              <div className='design-content-template-preview-details' data-testid={`${QA_ID_PREFIX}-TemplatePreviewDetails`}>
                <h3
                  style={{
                    margin: 0,
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    width: "inherit",
                    fontSize: "20px"
                  }}
                  data-testid={`${QA_ID_PREFIX}-TemplateName`}
                >
                  {selectedTemplate?.name}
                </h3>
                <div data-testid={`${QA_ID_PREFIX}-TemplateDetailsSpacer`}></div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    width: 'inherit'
                  }}
                  data-testid={`${QA_ID_PREFIX}-TemplateActionsContainer`}
                >
                  <Button
                    UNSAFE_className='chg-template-btn'
                    onClick={() => setShowTemplateOverlay(true)}
                    data-testid={`${QA_ID_PREFIX}-ChangeTemplateButton`}
                  >
                    Change template
                  </Button>
                  <Button
                    variant='primary'
                    onClick={() => {
                      setShowTemplateOverlay(true);
                      setEditSelectedTemplate(true);
                    }}
                    UNSAFE_className='continue-btn'
                    data-testid={`${QA_ID_PREFIX}-EditTemplateButton`}
                  >
                    Edit
                  </Button>
                </div>
              </div>
            </div>
          </div>
            :
          <div className='design-content-edit-form' data-testid={`${QA_ID_PREFIX}-EditForm`}>
            <div className='typo-1' data-testid={`${QA_ID_PREFIX}-RequiredFieldText`}>*Required field</div>
            <button
              className={`template-selection-container ${(errors?.["templateContent"]?.["message"]) ? 'template-selection-container-error' : ''}`}
              onClick={() => setShowTemplateOverlay(true)}
              data-testid={`${QA_ID_PREFIX}-TemplateSelectionButton`}
            >
              {templatePreview
                ?
                <div
                  className="design-content-template-preview"
                  id={`${QA_ID_PREFIX}-TemplateThumbnail`}
                  data-testid={`${QA_ID_PREFIX}-TemplatePreview`}
                >
                  <div
                    className='html-template-preview'
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(templatePreview) }}
                    data-testid={`${QA_ID_PREFIX}-TemplateHtmlPreview`}
                  />
                </div>
                :
                <div data-testid={`${QA_ID_PREFIX}-TemplateSelectionPrompt`}>
                <div className='icon-container' data-testid={`${QA_ID_PREFIX}-UploadIconContainer`}><CloudUpload size="large" /></div>
                <h4 data-testid={`${QA_ID_PREFIX}-TemplateSelectionHeading`}>Click here to choose a template*</h4>
                <div data-testid={`${QA_ID_PREFIX}-TemplateSelectionDescription`}>Start with a template to make creating your message easier.</div>
              </div>
              }
            </button>
          </div>
        }
        {errors?.["templateContent"]?.["message"] &&
          <InputErrorText className="" message={errors?.["templateContent"]["message"]} data-testid={`${QA_ID_PREFIX}-TemplateContentError`}/>
        }
        <Divider
            UNSAFE_style={{ marginTop: "24px" }}
            data-testid={`${QA_ID_PREFIX}-divider`}
        />
       
        <Controller
          name="attachments"
          control={control}
          render={({ field }) => (
            <AttachmentUploadContainer
              name="attachments"
              label="Attachments"
              accept={CAMPAIGN_FIELDS_V2[NOTIFICATION.CONFIGURATIONS][CONFIGURATIONS.ATTACHMENTS].accept}
              sizeLimit={CAMPAIGN_FIELDS_V2[NOTIFICATION.CONFIGURATIONS][CONFIGURATIONS.ATTACHMENTS].sizeLimit}
              maxFiles={CAMPAIGN_FIELDS_V2[NOTIFICATION.CONFIGURATIONS][CONFIGURATIONS.ATTACHMENTS].maxFiles}
              multiple={CAMPAIGN_FIELDS_V2[NOTIFICATION.CONFIGURATIONS][CONFIGURATIONS.ATTACHMENTS].multiple}
              id="DesignContentAttachments"
              error={errors.attachments ? errors.attachments.message : null}
              {...field}
              data-testid={`${QA_ID_PREFIX}-attachments-container`}
            />
          )}
        />
        
        <EditFormActionsFooter
          loading={continueButtonLoading}
          onPrevious={() => handlePrevious()}
          onSaveDraft={() => saveDraft()}
          onContinue={() => handleContinue(stepIndex)}
          data-testid={`${QA_ID_PREFIX}-ActionsFooter`}
        />
      </div>
      <TemplateOverlay
        open={showTemplateOverlay}
        handleClose={() => setShowTemplateOverlay(false)}
        editSelectedTemplate={editSelectedTemplate}
        setEditSelectedTemplate={setEditSelectedTemplate}
        data-testid={`${QA_ID_PREFIX}-TemplateOverlay`}
      />
      {templatePreviewDetails.showPreview &&
        <div className='template-gallery-preview-container' data-testid={`${QA_ID_PREFIX}-TemplateGalleryPreviewContainer`}>
          <TemplateGalleryPreview
            title={templatePreviewDetails.title}
            closePreview={() => setTemplatePreviewDetails({ showPreview: false, template: null, selectTemplate: null })}
            template={templatePreviewDetails.template}
            selectTemplate={templatePreviewDetails.selectTemplate}
            data-testid={`${QA_ID_PREFIX}-TemplateGalleryPreview`}
          />
        </div>
      }
    </>
  )
}

export default DesignContentEdit;